import gql from 'graphql-tag';

export const _REACTIVATE_ENDPOINT = gql`
	mutation reactivateEndpoint($participant: uuid!, $reference: uuid!) {
		update_risolto_channel_endpoint(
			where: { reference: { _eq: $reference }, participant: { _eq: $participant } }
			_set: { deactivated_at: null, deactivated_by: "NULL" }
		) {
			affected_rows
			returning {
				reference
			}
		}
	}
`;

export const _DEACTIVATE_ENDPOINT = gql`
	mutation deactivateEndpoint($participant: uuid!, $reference: uuid!, $deactivated_by: String!) {
		update_risolto_channel_endpoint(
			where: { reference: { _eq: $reference }, participant: { _eq: $participant } }
			_set: { deactivated_at: "now()", deactivated_by: $deactivated_by }
		) {
			affected_rows
			returning {
				reference
			}
		}
	}
`;
